var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullCalendar',{ref:"fullCalendar",class:_vm.isWidget ? 'fullcalendar-widget' : '',attrs:{"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }